import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'contract-types';

const updateContractTypeById = async (body, contractTypeId) => {
  const method = 'PUT';
  const url = `${USE_CASE_URL}/${contractTypeId}`;

  const json = await request({ method, url, body });
  return json;
};

export default updateContractTypeById;
